import { api } from "./client";
import type { AnbieterStartAntwort } from "./typen";

/** W68: Anmeldung mit Apple und Google im Web. Zum Anbieter geht es nur per `window.location.assign` mit der URL vom
 *  Server (keine Skripte, Frames oder Verbindungen zu Apple oder Google, CSP unveraendert); zurueck kommt man auf
 *  `/anmelden/rueckweg` (AnbieterRueckweg). Den Vorgang bindet der Server per Cookie an diesen Browser. */

export type Anbieter = "apple" | "google";
export type Zweck = "anmelden" | "verbinden" | "bestaetigen";
export type Gemerkt = { anbieter: Anbieter; zweck: Zweck; von: string };

/** Name des Anbieters in Saetzen („Apple ist jetzt verbunden.“). */
export const NAMEN: Record<Anbieter, string> = { apple: "Apple", google: "Google" };

const SPEICHER = "papiergaist.anbieter."; // sessionStorage, je state ein Eintrag

/** Der Seitenwechsel zum Anbieter an einer Stelle: jsdom navigiert nicht, die Tests fangen ihn hier ab. */
export const seite = { verlassen: (url: string) => window.location.assign(url) };

/** Nur Pfade dieser App (kein Schema, kein fremder Host), wie der Rueckweg nach dem frischen Link (nachweis.ts). */
function innerhalb(pfad: unknown): pfad is string {
  return typeof pfad === "string" && /^\/(?![/\\])/.test(pfad);
}

/** Startet den Ablauf: Server legt den Vorgang an und setzt das Bindungs-Cookie; danach weg zum Anbieter. */
export async function starten(anbieter: Anbieter, zweck: Zweck, von: string, passwort?: string): Promise<void> {
  if (!innerhalb(von)) von = "/"; // nur Pfade dieser App
  const a = await api<AnbieterStartAntwort>("/auth/anbieter/start", { json: { anbieter, client: "web", zweck, passwort } });
  try {
    sessionStorage.setItem(SPEICHER + a.state, JSON.stringify({ anbieter, zweck, von }));
  } catch {
    // ohne Speicher (privater Modus): zurueck geht es dann zum Posteingang
  }
  if (!a.url) throw new Error("Der Server hat keinen Weg zum Anbieter genannt.");
  seite.verlassen(a.url);
}

/** Liest einmal, was zum state gemerkt war, und loescht es. */
export function gemerkt(state: string): Gemerkt | null {
  try {
    const roh = sessionStorage.getItem(SPEICHER + state);
    sessionStorage.removeItem(SPEICHER + state);
    const wert = roh ? (JSON.parse(roh) as Partial<Gemerkt>) : null;
    if (
      wert &&
      (wert.anbieter === "apple" || wert.anbieter === "google") &&
      (wert.zweck === "anmelden" || wert.zweck === "verbinden" || wert.zweck === "bestaetigen") &&
      innerhalb(wert.von)
    )
      return { anbieter: wert.anbieter, zweck: wert.zweck, von: wert.von };
  } catch {
    // kaputter Eintrag oder ohne Speicher: nichts gemerkt
  }
  return null;
}
